import { createRoute } from "@tanstack/react-router";
import { FpRelationalMetricsChart } from "@/components/teams/fp-relational-metrics-chart";
import { TeamRosterPage } from "@/components/teams/team-roster-page";
import { Route as authenticatedRoute } from "../_authenticated";

const members = [
  {
    name: "Jimmy Lacy",
    title: "FP Relational Channel Champion",
    ownerId: "caac2ac4-8a98-4c7e-bd62-25ab132cbd55",
    image: "/assets/headshots/jimmy-lacy.png",
  },
  {
    name: "Jake Taylor",
    title: "FP Relational Consultant",
    ownerId: "054fb948-7256-4b16-825a-bde1aab6aefc",
    image: "/assets/headshots/jake-taylor.png",
  },
  {
    name: "Raleigh Keegan",
    title: "FP Relational Consultant",
    ownerId: "5626061a-1643-465d-aa79-c142552f6a91",
    image: "/assets/headshots/raleigh-keegan.png",
  },
  {
    name: "Jim Braden",
    title: "FP Relational Consultant",
    ownerId: "35a6d0a4-f785-421b-8a00-a63b1b7b2c5b",
    image: "/assets/headshots/jim-braden.png",
  },
  {
    name: "Landon Deaton",
    title: "FP Relational Consultant",
  },
];

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/teams/fp/consultants/relational",
  component: () => (
    <TeamRosterPage team="Relational Consultants" members={members}>
      <FpRelationalMetricsChart />
    </TeamRosterPage>
  ),
});
